import { Button, InputBase, Modal, Typography, Backdrop, CircularProgress } from "@mui/material";
import { AES } from "crypto-js";
import { ethers } from "ethers";
import KwilDB from "kwildb";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { setLoadedMoat } from "../../../redux/slices/loadedMoat";
import { setPrivateKey } from "../../../redux/slices/privateKeySlice";
import { setSecret } from "../../../redux/slices/secretSlice";
import { resetToggleControl } from "../../../redux/slices/toggleControlSlices"

export default function SignMoat({signMoat, setSignMoat, loader, setLoader, apiKey, encryptedSecret, selectedMoat, error, setError, emptyInput, setEmptyInput }) {
    const [signingPhrase, setSigningPhrase] = useState("")

    const dispatch = useDispatch()

    function executeSign() {
        setLoader(true)
        setTimeout(async function () {
            await window.ethereum.send("eth_requestAccounts")
            const provider = new ethers.providers.Web3Provider(window.ethereum)
            const signer = provider.getSigner()
            const signature = await signer.signMessage(signingPhrase)
            const address = await signer.getAddress()
            let privKeyResult
            let secretResult
            try {
                privKeyResult = JSON.parse(
                    await KwilDB.decryptKey(signature, address, apiKey)
                )
                secretResult = await KwilDB.decryptKey(signature, address, encryptedSecret)
                let encryptedKey = AES.encrypt(
                    JSON.stringify(privKeyResult),
                    "kwil"
                  ).toString();
                dispatch(setPrivateKey(encryptedKey))
                let encryptedSecret1 = AES.encrypt(secretResult, "kwil").toString()
                dispatch(setSecret(encryptedSecret1))
                dispatch(resetToggleControl())
                setLoader(false)
                setSignMoat(false)
            } catch (e) {
                setError("Something went wrong! Double check that you are using the correct Signing Phrase.")
                dispatch(setLoadedMoat(selectedMoat))
                setLoader(false)
                setSignMoat(false)
                return
            }
        }, 0)
    }


    return(
        <Modal
            open={signMoat}
            onClose={() => {
                setSignMoat(false)
                setLoader(false)
            }}
            sx={{ display: "flex" }}
        >
            <div className="modal-intro moat">
                <p className="modal-title">
                    Sign Moat
                </p>
                <Typography
                    sx={{
                        margin: "22px 32px 0px",
                        color: "#fff",
                        fontFamily: "Averta",
                        fontWeight: "400" }}
                >
                    Signing Phrase{emptyInput && <span>*</span>}
                </Typography>
                <InputBase
                    sx={{
                        backgroundColor: "#040417",
                        color: "#fff",
                        borderRadius: "9px",
                        pl: "10px",
                        minHeight: "45px",
                        margin: "5px 32px",
                        border: "1px solid #114BA3",
                        fontFamily: "Averta"
                      }}
                    onChange={(e) => setSigningPhrase(e.target.value)}
                    onKeyDown={(e) => {
                        if (e.key === "Enter") {
                            if(signingPhrase) {
                                e.preventDefault()
                                executeSign()
                            } else {
                                setEmptyInput(true)
                                setError("You must enter a valid signing phrase.")
                            }
                        }
                    }}
                    placeholder="Type Signing Phrase..."
                    value={signingPhrase}
                    required
                />
                <Button
                    type="submit"
                    sx={{
                        color: "#fff",
                        background: "linear-gradient(90deg, #118EA0 0%, #50C9DB 100%)",
                        opacity: "0.9",
                        textTransform: "none",
                        margin: "40px auto",
                        borderRadius: "9px",
                        width: "19.028vw",
                        height: "49px",
                        fontFamily: "Averta",
                        fontWeight: "400",
                        fontSize: "20px",
                        lineHeight: "24px"
                      }}
                    onClick={() => {
                        if(signingPhrase) {
                            executeSign()
                        } else {
                            setEmptyInput(true)
                            setError("You must enter a valid signing phrase.")
                        }
                    }}
                >
                    Submit
                </Button>
                <Backdrop open={loader} sx={{ display: "flex" }}>
                    <CircularProgress sx={{ margin: "auto", color: "#linear-gradient(90deg, #118EA0 0%, #50C9DB 100%)" }} />
                </Backdrop>
            </div>
        </Modal>
    )
}